export default "__VITE_ASSET__BUP118EU__"